import {Route, Routes} from 'react-router-dom';

import {Requests} from './yeu-cau';
import {Customers} from './danh-sach';
import {PitAgreements} from './hop-dong';

export const Customer = () => {

  return (
    <Routes>
      <Route path="yeu-cau" element={<Requests/>}/>
      <Route path="danh-sach" element={<Customers/>}/>
      <Route path="hop-dong" element={<PitAgreements/>}/>
    </Routes>
  );
}
